<template>
  <div ref="qrcode" class="qrcodeWrapper">
    <div id="qrcodeCon" class="qrcode-center"/>
    <!-- <van-image src="https://danone-apac-cn-amn-visitor-training-uat.oss-cn-shanghai.aliyuncs.com/2021/6/3/5ccd1b26-7e22-4c1e-b8f5-44444f09f6f8.png"/> -->
    <van-image :src="url"/>
    <!-- <div ref="footer" class="dialog-footer">
      <van-button type="info" @click="download">下载二维码</van-button>
    </div> -->
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  name: 'ExamQrcode',
  data() {
    return {
      url: this.$route.query.url,
      imgFile: ''
    }
  },
  created() {
    // this.init()
  },
  methods: {
    showQrcode() {
      const url = this.url
      document.getElementById('qrcodeCon').innerHTML = ''
      new QRCode('qrcodeCon', { // 第一个入参是组件id
        text: url, // 生成二维码的文本
        width: 300,
        height: 300,
        colorDark: '#000000', // 二维码色
        colorLight: '#ffffff', // 背景色
        correctLevel: QRCode.CorrectLevel.H // 容错等级，H是heigh，最高，所以二维码看起来很密
      })
      // this.imgFile = this.base64ImgtoFile(base64Img)
    },
    base64ImgtoFile(dataurl, filename = 'file') {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const suffix = mime.split('/')[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], `${filename}.${suffix}`, {
        type: mime
      })
    },
    download() {
      var canvasData = this.$refs.qrcode.getElementsByTagName('canvas')
      // var a = document.createElement('a')
      // var event = new MouseEvent('click') // 创建一个单击事件
      // a.href = canvasData[0].toDataURL('image/png')
      // a.download = 'drcQrcode'
      // a.dispatchEvent(event) // 触发a的单击事件
      this.imgFile = canvasData[0].toDataURL('image/png')
    },
    init() {
      setTimeout(() => {
        this.showQrcode()
      }, 100)
    }
  }
}
</script>
<style lang="less">
.qrcodeWrapper{
  text-align: center;
  margin: 0 auto;
  padding:20px;
  .qrcode-text{
    font-size: 40px;
    font-weight: 600;
    line-height: 30px;
    margin-top: 30px;
  }
}
#qrcodeCon{
  width: 300px;
  height:300px;
  margin: 0 auto;
  display: none;
}
.dialog-footer {
  margin: 20px auto
}
</style>
